import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';
import CssBaseline from '@material-ui/core/CssBaseline';
import ThemeProvider from '@material-ui/styles/ThemeProvider';

import store, { history } from 'config/store';
import theme from 'config/theme';
import { AppContainer } from 'containers/views';
import { DialogTemplateContainer } from 'containers/templates';

import 'typeface-roboto';
import './index.css';

const target = document.querySelector('#root');

render(
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <DialogTemplateContainer />
        <AppContainer />
      </ThemeProvider>
    </ConnectedRouter>
  </Provider>,
  target
);
